import type { LawFirmCaseLawyerMap, LawFirmCaseLawyerMapExtra } from '~/models'
import { $apiDelete, $apiGet, $apiPost, $apiPut } from '~/utils/request'

export const GetByLawFirmCaseEncryptionId = params => $apiGet<(LawFirmCaseLawyerMap & LawFirmCaseLawyerMapExtra)[]>(`/v1/lawFirmCaseLawyerMap/byLawFirmCaseEncryptionId`, params)

export const GetMyNewItem = () => $apiGet<LawFirmCaseLawyerMap & LawFirmCaseLawyerMapExtra>(`/v1/lawFirmCaseLawyerMap/myNewItem`)
